import React from 'react'
import Card from '../../molecules/Card'
import smallPic from "../../../assets/pics/square.jpg"
import Title from '../../atoms/Title'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'



export default function Allnewscontent({data}) {
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
  const noData = t("common.noData");
  
  // console.log("allNews in all news data",data)

  const news =[
    {
      id: 0,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 1,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 2,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 3,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 4,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 5,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 6,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 7,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 8,

      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 9,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {    
      id: 10,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },

    {
      id: 11,
      title:"التنسيق الحضارى يطلق اسم محمد مشعل في مشروع عاش هنا",
      date:"1 نوفمبر 2023",
      image:smallPic,
      image_alt:"small image"
    },
  ]

  return (
    <div className='h-fit bg-rd-200 mb-10 md:mb-15 lg:mb-20 mt-20'>
        <div className='text-start m-6 pt-[20px]'>
          <Title primary>{t("news.list.title")}</Title>
        </div>

        <div className='flex flex-col justify-center items-center'>

        
              <div className='grid grid-cols-1 md:grid-cols-2 gap-3 bg-rd-400 pe-[4px] w-11/12 '>
                {/* {news.map((newss, index)=> */}
                {data?.map((newss, index)=>
                <div key={index} className='flex flex-col justify-center items-center'>
                  <div className='mb-[8px]'>
                    <Link 
                    to={`/allnews/${newss.id}`}
                    state={{ newsData: newss }} // Pass data using `state`
                    >

                    <Card
                      horizontal
                      title={(isArabic ? newss.titleA : newss.titleE) || noData}
                      date={(isArabic ? newss.createDate : newss.createDateE) || noData}
                      imageSrc={newss.image}
                      alt={isArabic ? newss.titleA : newss.titleE}
                      square
                      />

                    </Link>
                  </div>
                  <div className="h-[2px] w-11/12 lg:w-9/12 bg-[#F5F5F5] mx-[10px] lg:mx-[80px]"></div>

                </div>
                )}

              </div>
          
        </div>

    </div>
  )
}
